import { forwardRef } from "react";

import Chip from "@mui/material/Chip";
import Badge from "@mui/material/Badge";

export const ChipWithBadge = forwardRef((props, ref) => {
	let { chipProps, badgeProps, badgePosition } = props;

	badgePosition = badgePosition === "start" ? "start" : "end";

	return (
		<Chip
			{...chipProps}
			sx={{
				"& .MuiChip-label": {
					padding: badgePosition === "start" ? "0 12px 0 0" : "0 0 0 12px",
				},
				...(chipProps?.sx && chipProps.sx),
			}}
			label={
				<>
					{badgePosition === "end" ? chipProps.label : <></>}
					<Badge
						variant="inline"
						color={chipProps.varaint === "outlined" ? "none" : "white"}
						{...badgeProps}
						sx={{
							color: `${chipProps.color || "primary"}.main`,
							margin: "0 3px",
							"& .MuiBadge-badge": {
								background: "var(--white)",
							},
							...(badgeProps?.sx && badgeProps.sx),
						}}
					/>

					{badgePosition === "start" ? chipProps.label : <></>}
				</>
			}
		/>
	);
});
ChipWithBadge.muiName = Chip.muiName;
